<template>
    <div class=''>
        <router-view></router-view>
    </div>
</template>

<script>
  export default {
    name: "AppLayout",
    data() {
      return {
        minHeight:0
      }
    },
    methods: {}
  }
</script>

<style scoped lang='less'>

</style>



// WEBPACK FOOTER //
// src/views/layouts/index.vue